import axios from 'axios';
import {
  cleanLocalStorage,
  encodeQueryData,
  errorToast,
  getDeviceToken,
  getJWTToken,
  getLocalStorageItem,
  setLocalStorageItem
} from '../utils/helper';
import { API_BASE_URL } from '../core/env.configs';

const BASE_URL = API_BASE_URL || 'https://staging-api.shoorah.io/';
//const BASE_URL = 'https://g5hlq59s-3003.inc1.devtunnels.ms/';

/** `{ a: 1, b: '' }` → `a=1`; empty and null values are dropped. */
const toQuery = (params = {}) =>
  new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== '' && value != null)
  ).toString();

const GetApi = async (tag = '', isHeader = false) => {
  try {
    const path = tag.startsWith('/company/v1')
      ? tag.slice(1)
      : tag.startsWith('/admin/v1')
      ? tag.slice(1)
      : 'admin/v1' + tag;

    const data = await axios.get(BASE_URL + path, {
      headers: isHeader
        ? {
            Authorization: getJWTToken()
          }
        : {}
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const GetKidsApi = async (tag = '', isHeader = false) => {
  try {
    const data = await axios.get(BASE_URL + 'admin/v1/kids' + tag, {
      headers: {
        Authorization: getJWTToken(),
        devicetype: 1,
        devicetoken: 1
      }
    });
    console.log(data?.data);

    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const GetKidsByIdApi = async (id, tag = '', isHeader = false) => {
  try {
    const data = await axios.get(BASE_URL + 'api/v1/kids/' + id + tag, {
      headers: isHeader
        ? {
            Authorization: getJWTToken(),
            devicetype: 1,
            devicetoken: 1
          }
        : {}
    });
    console.log(data?.data);

    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const PostApi = async (tag = '', reqBody, isHeader = false, flag = false) => {
  console.log(tag, isHeader, flag);
  let flagCheck = flag
    ? 'multipart/form-data; boundary=----WebKitFormBoundaryueI4YvrqiXxUgVGA'
    : 'application/json';

  try {
    const data = await axios.post(BASE_URL + 'admin/v1' + tag, reqBody, {
      headers: isHeader
        ? {
            'Content-Type': flagCheck,
            accept: 'application/json',
            deviceToken: getLocalStorageItem('deviceToken'),
            deviceType: 3,
            Authorization: getJWTToken()
          }
        : {}
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const PostKidsApi = async (tag = '', reqBody, isHeader = false, flag = false) => {
  let flagCheck = flag ? 'multipart/form-data' : 'application/json';

  try {
    const data = await axios.post(BASE_URL + 'admin/v1/kids' + tag, reqBody, {
      headers: isHeader
        ? {
            'Content-Type': flagCheck,
            accept: 'application/json',
            deviceToken: getLocalStorageItem('deviceToken'),
            deviceType: 3,
            Authorization: getJWTToken()
          }
        : {}
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const DeleteApi = async (tag = '', isHeader = false) => {
  try {
    const data = await axios.delete(BASE_URL + 'admin/v1' + tag, {
      headers: isHeader
        ? {
            'Content-Type': 'application/json',
            accept: 'application/json',
            Authorization: getJWTToken(),
            deviceToken: getDeviceToken()
          }
        : {}
    });
    return data;
  } catch (e) {
    console.log(e);
    ErrorHandler(e);
  }
};

const DeleteKidsApi = async (tag = '', isHeader = false) => {
  try {
    const data = await axios.delete(BASE_URL + 'api/v1/kids' + tag, {
      headers: isHeader
        ? {
            'Content-Type': 'application/json',
            accept: 'application/json',
            Authorization: getJWTToken(),
            deviceToken: getDeviceToken,
            deviceType: 3
          }
        : {}
    });
    return data;
  } catch (e) {
    console.log(e);
    ErrorHandler(e);
  }
};

const PutApi = async (tag = '', reqBody, isHeader, isJSON = false) => {
  const contentType = {
    'Content-Type': 'application/json'
  };
  const headers = {
    accept: 'application/json',
    Authorization: getJWTToken(),
    ...(isJSON ? contentType : {})
  };
  try {
    const data = await axios.put(BASE_URL + 'admin/v1' + tag, reqBody !== null && reqBody, {
      headers: isHeader ? headers : {}
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const PutKidsApi = async (tag = '', reqBody, isHeader, isJSON = false) => {
  const contentType = {
    'Content-Type': 'application/json'
  };
  const headers = {
    accept: 'application/json',
    Authorization: getJWTToken(),
    deviceType: 3,
    ...(isJSON ? contentType : {})
  };
  try {
    const data = await axios.put(BASE_URL + 'admin/v1/kids' + tag, reqBody !== null && reqBody, {
      headers: headers
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const PutApiWithFormData = async (tag = '', reqBody, isHeader = false, flag = false) => {
  let flagCheck = flag
    ? 'multipart/form-data; boundary=----WebKitFormBoundaryueI4YvrqiXxUgVGA'
    : 'application/json';

  try {
    const data = await axios.put(BASE_URL + 'admin/v1' + tag, reqBody, {
      headers: isHeader
        ? {
            'Content-Type': flagCheck,
            accept: flagCheck,
            Authorization: getJWTToken()
          }
        : {}
    });
    return data;
  } catch (e) {
    console.log('🚀 ~ PutApi FormData ~ e:', e);
    ErrorHandler(e);
  }
};

const PatchApi = async (tag = '', reqBody, isHeader, isJSON = false) => {
  const contentType = {
    'Content-Type': 'application/json'
  };
  const headers = {
    accept: 'application/json',
    Authorization: getJWTToken(),
    ...(isJSON ? contentType : {})
  };
  try {
    const data = await axios.patch(BASE_URL + 'admin/v1' + tag, reqBody !== null && reqBody, {
      headers: isHeader ? headers : {}
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const ErrorHandler = async (e) => {
  if (e.response?.data?.message) {
    if (e.response?.data?.code === 498) {
      RefreshToken();
    } else if (e.response?.data?.code === 401) {
      errorToast(e.response?.data?.message);
      cleanLocalStorage();
      window.location.href = '/login';
    } else {
      errorToast(e.response?.data?.message);
    }
  } else if (e.response?.data) {
    if (e.response?.data?.meta?.code === 498) {
      RefreshToken();
    } else if (e.response?.data?.code === 401) {
      errorToast(e.response?.data?.message);
      cleanLocalStorage();
      window.location.href = '/login';
    } else {
      errorToast(e.response?.data?.meta?.message);
    }
  } else {
    errorToast('Something went wrong');
  }
};

const RefreshToken = async () => {
  await axios
    .post(
      `${BASE_URL}admin/v1/refresh-token`,
      {},
      { headers: { 'refresh-token': getLocalStorageItem('refreshToken') } }
    )
    .then(async (response) => {
      if (response.data.meta.code === 1) {
        setLocalStorageItem('token', response.data.meta.token);
        window.location.reload();
      }
    })
    .catch(async (error) => {
      if (error.response.data.code === 401) {
        await Api.logoutUser();
        cleanLocalStorage();
        window.location.href = '/login';
      } else {
        cleanLocalStorage();
        window.location.href = '/login';
      }
    });
};

const DownloadApi = async (tag = '', fileName = 'SosReport') => {
  try {
    const res = await axios.get(BASE_URL + 'admin/v1' + tag, {
      headers: {
        deviceType: 3,
        Authorization: getJWTToken()
      },
      responseType: 'blob'
    });
    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url_2 = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url_2;
    a.download = `${fileName}.pdf`; // Specify the filename
    a.click();
    window.URL.revokeObjectURL(url_2);
  } catch (err) {}
};

const PostApiBlob = async (tag = '', reqBody) => {
  try {
    const res = await axios.post(BASE_URL + 'admin/v1' + tag, reqBody, {
      headers: {
        deviceType: 3,
        Authorization: getJWTToken()
      },
      responseType: 'blob'
    });
    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url_2 = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url_2;
    a.download = reqBody.graphName; // Specify the filename
    a.click();
    window.URL.revokeObjectURL(url_2);
  } catch (e) {
    ErrorHandler(e);
  }
};

export const Api = {
  //LRF FLOW APIs
  login: (reqBody) => PostApi('/login', reqBody),
  forgotPassword: (reqBody) => PostApi('/forgot-password', reqBody),
  resetPassword: (reqBody) => PostApi('/reset-password', reqBody),
  adminVerifyOtp: (reqBody) => PostApi('/verify-otp', reqBody),
  changePassword: (reqBody) => PostApi('/change-password', reqBody, true),
  adminList: () => GetApi('/admin-list', true),

  //Dashboard
  getDashboardData: () => GetApi(`/content-count`, true),
  getCleanseData: (type) => GetApi(`/overview?type=${type}`, true),
  getGuidanceData: () => GetApi(`/guidance-count`, true),

  //Kids Dashboard
  getMoodStats: () => GetApi(`/kids-mood/stats`, false),
  getKidsDetailsStats: () => GetKidsApi(`/kids-stats`, false),
  getAccountDetailsStats: () => GetApi(`/account-details-stats`, false),
  getAllStats: () => GetApi(`/get-all-stats`, false),
  getFocusStats: () => GetApi(`/get-focus-stats`, false),
  getGamesStats: () => GetApi(`/get-games-stats`, false),
  getAudioStats: () => GetKidsApi(`/media-stats`, true),
  getStoryStats: () => GetApi(`/get-story-stats`, false),
  getExercises: () => GetApi(`/get-exercises`, false),

  //Kids Management
  getKidsContentCategory: (type) => GetKidsApi(`/categories?type=${type}`, true),
  getParentList: (searchKey, pageNum, limit) =>
    GetKidsApi(`/parents?search=${searchKey}&page=${pageNum}&limit=${limit}`, true),
  getKidsList: (searchKey, pageNum, limit, query) =>
    GetKidsApi(`/admin-list?search=${searchKey}&page=${pageNum}&limit=${limit}${query}`, true),
  getKidById: (id) => GetKidsApi(`/admin-list/${id}`, true),
  getKidsPods: (limit, pageNum, searchKey) =>
    GetKidsApi(`/pods?limit=${limit}&page=${pageNum}&search=${searchKey}`, true),
  getKidsPodsById: (id) => GetKidsApi(`/pods/${id}`, true),
  getKidsAffirmation: (limit, pageNum, searchKey) =>
    GetKidsApi(`/affirmation?limit=${limit}&page=${pageNum}&search=${searchKey}`, true),
  getKidCategories: () => GetKidsApi('/categories'),
  getKidsAffirmationById: (id) => GetKidsApi(`/affirmation/${id}`, true),
  getKidsStories: (limit, pageNum, searchKey) =>
    GetKidsApi(`/stories?limit=${limit}&page=${pageNum}&search=${searchKey}`, true),
  getKidsStoryById: (id) => GetKidsApi(`/stories/${id}`, true),

  addKidsContentCategory: (payload) => PostKidsApi('/categories', payload, true),
  putKidsPods: (data, id) => PutKidsApi(`/pods/${id}`, data, true),
  addKidsPods: (payload) => PostKidsApi(`/pods`, payload, true),
  deleteKidsPods: (id) => DeleteKidsApi(`/pods/${id}`, true),
  addKidsAffirmation: (payload) => PostKidsApi(`/affirmation`, payload, true),
  putKidsAffirmation: (data, id) => PutKidsApi(`/affirmation/${id}`, data, true),
  deleteKidsAffirmation: (id) => DeleteKidsApi(`/affirmation/${id}`, true),
  addKidsStories: (payload) => PostKidsApi(`/stories`, payload, true),
  putKidsStories: (data, id) => PutKidsApi(`/stories/${id}`, data, true),
  deleteKidsStories: (id) => DeleteKidsApi(`/stories/${id}`, true),
  uploadThumbnail: (file) => PostKidsApi(`/addFileToAws`, file, true, true),

  //Sub Admin Menu APIs
  getAdmins: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/admins?id=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}${filterQuery}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  addEditAdmin: (reqBody) => PostApi('/admins', reqBody, true),
  deleteAdmin: (userId) => DeleteApi(`/admins?userId=${userId}`, true),

  //User APIs
  getFilterData: () => GetApi(`/filter-user-data`, true),
  getUsers: (
    page,
    perPage,
    searchKey,
    filterQuery,
    sortBy,
    sortOrder,
    company,
    includeAdmin = false,
    isMembers
  ) =>
    GetApi(
      `/users?page=${page}&perPage=${perPage}&searchKey=${searchKey}${filterQuery}&sortBy=${sortBy}&sortOrder=${sortOrder}&includeAdmin=${includeAdmin}${
        company ? '&company=' + company : ''
      }${isMembers ? '&isMembers=' + isMembers : ''}`,
      true
    ),
  updateUserDetail: (reqBody) => PutApi('/users', reqBody, true),
  getUserDetail: (id) => GetApi(`/users/${id}`, true),

  getUserFeels: (id, reportType) =>
    GetApi(`/users-mood?userId=${id}&reportType=${reportType}`, true),
  getUserProfessonalFeels: (id, reportType) =>
    GetApi(`/user-professonal-report?userId=${id}&reportType=${reportType}`, true),
  getUserBeforeSleepFeels: (id, reportType) =>
    GetApi(`/user-before-sleep-report?userId=${id}&reportType=${reportType}`, true),
  getUserAfterSleepFeels: (id, reportType) =>
    GetApi(`/user-after-sleep-report?userId=${id}&reportType=${reportType}`, true),
  getPerformanceData: (id, contentType, page, perPage) =>
    GetApi(
      `/performance-data?userId=${id}&contentType=${contentType}&page=${page}&perPage=${perPage}`,
      true
    ),

  getBadgeCount: (id) => GetApi(`/badge-count?userId=${id}`, true),

  getBadgeList: (id, badgeType) => GetApi(`/badge?userId=${id}&badgeType=${badgeType}`, true),

  //pay to partner api
  addPartnerPayment: (data) =>
    PostApi('/edit-introduce?type=update-payment-info', data, true, true),

  //push notifications
  getAllNotifications: (type, page, perPage, searchKey, isFanNotification) =>
    GetApi(
      `/notification?page=${page}&perPage=${perPage}&searchKey=${searchKey}&notificationListType=${type}&isFanNotification=${isFanNotification}`,
      true
    ),
  addPushNotification: (reqBody) => PostApi('/notification', reqBody, true),
  getUnreadNotificationCount: () => GetApi('/unread-notification', true),
  deleteNotification: (notificationId, deleteType) =>
    DeleteApi(`/notification?deleteType=${deleteType}&notificationId=${notificationId}`, true),
  getUserEmailList: (url, page, perPage, searchKey) =>
    GetApi(`/${url}?page=${page}&perPage=${perPage}&searchKey=${searchKey}`, true),

  addEditDeviceToken: () => PostApi('/device-token', {}, true),

  //Content Management
  //Focus
  getFocusList: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/focus?id=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}${filterQuery}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),

  getDraftFocusList: () => GetApi(`/draft-focus`, true),
  getFocusNamesList: (type) => GetApi(`/focus/${type}`, true),
  getExpertFocusList: (type) => GetApi(`/getCategoriesByContentIdPopulate/${type}`, true),
  getFocusById: (id) => GetApi(`/focus/view/${id}`, true),
  addEditFocus: (reqBody) => PostApi('/focus', reqBody, true),
  addEditDraftFocus: (reqBody) => PostApi('/draft-focus', reqBody, true),
  deleteFocus: (focusId) => DeleteApi(`/focus?focusId=${focusId}`, true),

  //Meditations
  getMeditationsList: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/meditation?id=${id ? id : ''}&page=${page}&perPage=${perPage}&searchKey=${searchKey}${
        filterQuery || ''
      }&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  getExpertMeditationsList: (page, perPage, searchKey, sortBy, sortOrder, id) =>
    GetApi(
      `/meditation?expertId=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),

  getDraftMeditationsList: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/draft-meditation?&page=${page}&perPage=${perPage}&searchKey=${searchKey}${
        filterQuery || ''
      }&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  getMeditationById: (id) => GetApi(`/meditation/${id}`, true),
  addMeditation: (reqBody) => PostApi('/meditation', reqBody, true),
  addDraftMeditation: (reqBody) => PostApi('/draft-meditation', reqBody, true),
  deleteMeditation: (meditationId) => DeleteApi(`/meditation?meditationId=${meditationId}`, true),

  // Guidance
  getGuidancesList: (page, perPage, searchKey, sortBy, sortOrder, id) =>
    GetApi(
      `/guidance?id=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  getExpertGuidancesList: (
    page,
    perPage,
    searchKey,
    sortBy,
    sortOrder,
    id,
    is_draft = false,
    createdBy
  ) =>
    GetApi(
      `/guidance?expertId=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}&is_draft=${is_draft}&createdBy=${createdBy}`,
      true
    ),

  getGuidanceById: (id) => GetApi(`/guidance/${id}`, true),
  addGuidance: (reqBody) => PostApi('/guidance', reqBody, true),
  addDraftGuidance: (reqBody) => PostApi('/draft-guidance', reqBody, true),
  deleteGuidance: (guidanceId) => DeleteApi(`/guidance?guidanceId=${guidanceId}`, true),

  //Affirmation
  getAffirmationList: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/affirmation?id=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}${filterQuery}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),

  getDraftAffirmationList: () => GetApi(`/draft-affirmation`, true),
  getAffirmationById: (id) => GetApi(`/affirmation/${id}`, true),
  addEditAffirmation: (reqBody) => PostApi('/affirmation', reqBody, true),
  addEditDraftAffirmation: (reqBody) => PostApi('/draft-affirmation', reqBody, true),
  addEditAffirmationCSV: (reqBody, flag) => PostApi('/affirmation-csv', reqBody, true, flag),

  deleteAffirmation: (affirmationId) =>
    DeleteApi(`/affirmation?affirmationId=${affirmationId}`, true),

  //Gratitude
  getGratitudeList: (page, perPage, searchKey, sortBy, sortOrder, id) =>
    GetApi(
      `/gratitude?id=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  addGratitude: (reqBody) => PostApi('/gratitude', reqBody, true),
  deleteGratitude: (gratitudeId) => DeleteApi(`/gratitude?gratitudeId=${gratitudeId}`, true),

  // Habit icon library (icon picker on the Add/Edit Habit page)
  getHabitIcons: () => GetApi('/habit-icons', true),
  addHabitIcon: (reqBody) => PostApi('/habit-icons', reqBody, true),
  // Habits (unified habit catalog — new /habit endpoints)
  getHabitList: (page, perPage, searchKey, sortBy, sortOrder, filterQuery = '') =>
    GetApi(
      `/habit?page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}${filterQuery}`,
      true
    ),
  getHabitById: (id) => GetApi(`/habit/${id}`, true),
  addHabit: (reqBody) => PostApi('/habit', reqBody, true),
  deleteHabit: (habitId) => DeleteApi(`/habit?habitId=${habitId}`, true),

  //BedTime Stories
  getBedTimeStoriesList: (page, perPage, searchKey) =>
    GetApi(`/story?page=${page}&perPage=${perPage}&searchKey=${searchKey}`, true),
  deleteBedTimeStory: (storyId) => DeleteApi(`/story?storyId=${storyId}`, true),

  //Earnings
  getEarnings: (page, perPage, searchKey, sortBy, sortOrder) =>
    GetApi(
      `/earnings?page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),

  //Sounds
  getSoundsList: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/sound?id=${id ? id : ''}&page=${page}&perPage=${perPage}&searchKey=${searchKey}${
        filterQuery || ''
      }&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  getExpertSoundsList: (page, perPage, searchKey, sortBy, sortOrder, id) =>
    GetApi(
      `/sound?expertId=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  getDraftSoundsList: () => GetApi(`/draft-sound`, true),
  getSoundById: (id) => GetApi(`/sound/${id}`, true),
  addSound: (reqBody) => PostApi('/sound', reqBody, true),
  addDraftSound: (reqBody) => PostApi('/draft-sound', reqBody, true),
  deleteSound: (soundId) => DeleteApi(`/sound?soundId=${soundId}`, true),

  //Top Picks
  getTopPicksList: (page, perPage, searchKey, id) =>
    GetApi(
      `/top-picks?id=${id ? id : ''}&page=${page}&perPage=${perPage}&searchKey=${searchKey}`,
      true
    ),
  addTopPick: (reqBody) => PostApi('/top-picks', reqBody, true),
  deleteTopPick: (pickId) => DeleteApi(`/top-picks?pickId=${pickId}`, true),

  //Manifestation
  getManifestationList: (page, perPage, searchKey) =>
    GetApi(`/manifestation?page=${page}&perPage=${perPage}&searchKey=${searchKey}`, true),
  deleteManifestation: (manifestationId) =>
    DeleteApi(`/manifestation?manifestationId=${manifestationId}`, true),

  //content approval
  getContentApprovalList: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/content-approval?id=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}${filterQuery}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  getContentApprovalView: (type, id) => GetApi(`/content-approval/${type}/${id}`, true),
  updateApproval: (reqBody) => PutApi('/content-approval', reqBody, true),

  //CMS
  getCMSList: (page, perPage, searchKey) =>
    GetApi(`/cms?page=${page}&perPage=${perPage}&searchKey=${searchKey}`, true),
  addEditCMS: (reqBody) => PostApi('/cms', reqBody, true),
  deleteCMS: (cmsId) => DeleteApi(`/cms?cmsId=${cmsId}`, true),

  //config
  getConfigList: () => GetApi('/config', true),
  updateConfig: (reqBody) => PostApi('/config', reqBody, true),

  //drafts
  getDraftsList: (page, perPage, searchKey, filterQuery, sortBy, sortOrder) =>
    GetApi(
      `/my-drafts?page=${page}&perPage=${perPage}&searchKey=${searchKey}${filterQuery}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),

  // bulk action api
  postBulkAction: (reqBody) => PostApi('/content-status', reqBody, true),

  // bulk user action api
  postUserBulkAction: (reqBody) => PostApi('/user-status', reqBody, true),
  //content type
  getAllContentType: (contentTypeId) =>
    GetApi(`/content-type?contentType=${contentTypeId}`, {}, true),

  // config tutorial
  createTutorial: (reqBody) => PostApi('/tutorial-video', reqBody, true),

  // logout
  logoutUser: () => DeleteApi(`/device-token`, {}, true),
  adminAccess: () => GetApi(`/admin-access`, {}, true),
  getTutorialByType: (id) => GetApi(`/tutorial-video?contentType=${id}`, {}, true),

  // Shoorah Pods
  getShoorahPodsList: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/shoorah-pods?id=${id ? id : ''}&page=${page}&perPage=${perPage}&searchKey=${searchKey}${
        filterQuery || ''
      }&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  getExpertShoorahPodsList: (page, perPage, searchKey, sortBy, sortOrder, id) =>
    GetApi(
      `/shoorah-pods?expertId=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),

  getDraftShoorahPodsList: () => GetApi(`/draft-shoorah-pods`, true),
  getShoorahPodsById: (id) => GetApi(`/shoorah-pods/${id}`, true),
  addShoorahPods: (reqBody) => PostApi('/shoorah-pods', reqBody, true),
  addDraftShoorahPods: (reqBody) => PostApi('/draft-shoorah-pods', reqBody, true),
  deleteShoorahPods: (podId) => DeleteApi(`/shoorah-pods?podId=${podId}`, true),
  getSOSClick: (dateRange) => PostApi('/sos-count', dateRange, true),
  addCompany: (companyData) => PostApi('/company/addCompany', companyData, true),
  getAllCompanies: (page, perPage, searchKey, sortBy, sortOrder) =>
    GetApi(
      `/company/company-list?page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  getInstantSupportAllCompanies: (page, perPage, searchKey, sortBy, sortOrder) =>
    GetApi(
      `/company/support-company-list?page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  editCompany: (data, id) => PutApi(`/company/update/${id}`, data, true),
  getCompanyData: (id) => GetApi(`/company/${id}`, true),
  getEarningCount: () => GetApi('/company/contents/count', true),
  getTransactionData: (page, perPage, searchKey) =>
    GetApi(`/earning/companyEarnings?page=${page}&perPage=${perPage}&searchKey=${searchKey}`, true),
  getCompanyList: (params) => {
    // Build query string from params object
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append('page', params.page);
    if (params.perPage) queryParams.append('perPage', params.perPage);
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    if (params.searchKey) queryParams.append('searchKey', params.searchKey);

    return GetApi(`/company/company-list?${queryParams.toString()}`, true);
  },
  getParentEligibleCompanies: () => GetApi('/company/parentCompanies', true),
  getChildCompaniesByParentId: (
    parentId,
    page = 1,
    perPage = 10,
    searchKey = '',
    sortBy = 'createdAt',
    sortOrder = -1
  ) =>
    GetApi(
      `/company/child-companies/${parentId}?page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  raiseChildCompanySupport: (payload) => PostApi('/company/child-companies/support', payload, true),
  getOverallCompanyGraph: (id, year, type) =>
    GetApi(
      `/company/moods/analytics?${
        type ? `type=${type?.toLowerCase()}` : `company_id=${id}`
      }&year=${year}`,
      true
    ),

  // Instant Support SUPERADMIN APIs B2B
  getInstantSupportList: (
    pageNumber,
    pageSize,
    searchKey,
    sortByKey,
    orderByKey,
    startDate,
    endDate,
    includeCustomPlans
  ) => {
    let url = `/instantSupport/?pageNumber=${pageNumber}&pageSize=${pageSize}`;

    // Add optional parameters if they have values
    if (searchKey) url += `&searchKey=${encodeURIComponent(searchKey)}`;
    if (sortByKey) url += `&sortByKey=${sortByKey}`;
    if (orderByKey !== undefined && orderByKey !== null) url += `&orderByKey=${orderByKey}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (includeCustomPlans) url += `&includeCustomPlans=${includeCustomPlans}`;
    // console.log("pageNumber pageSize searchKey sortByKey orderByKey startDate endDate", pageNumber,
    // pageSize,
    // searchKey,
    // sortByKey,
    // orderByKey,
    // startDate,
    // endDate)
    return GetApi(url, true);
  },
  getInstantSupportCompanyDetails: (reqBody) =>
    PostApi(`/instantSupport/support-details`, reqBody, true),
  postInstantSupportCompanyStatusActivateDeactivate: (reqBody) =>
    PostApi('/instantSupport/activate-deactivate', reqBody, true),
  updateInstantSupportCompanyStatus: (reqBody) =>
    PutApi('/instantSupport/update-status', reqBody, true),
  postInstantSupportAddCompany: (reqBody) => PutApi('/instantSupport/add-company', reqBody, true),
  postInstantSupportAddAccount: (reqBody) => PostApi('/instantSupport/add-account', reqBody, true),
  getInstantSupportInsights: () => GetApi('/instantSupport/insights', true),

  // Marketplace Shoorah SuperAdmin APIs
  getMarketplaceCompaniesList: (
    pageNumber,
    pageSize,
    sortByKey,
    orderByKey,
    searchKey,
    createdAt
  ) => {
    let url = `/marketplace/companies?page=${pageNumber}&perPage=${pageSize}&sortBy=${sortByKey}&orderBy=${orderByKey}&search=${searchKey}`;
    return GetApi(url, true);
  },

  getMarketplaceOffersCatagory: () => GetApi('/getCategoriesByContentIdPopulate/20', true),

  getMarketplaceCompanyInfo: (id) => GetApi(`/marketplace/company/${id}`, true),

  getMarketplaceOffersList: (
    pageNumber,
    pageSize,
    sortByKey,
    orderByKey,
    listType,
    searchKey,
    createdAt = '',
    createdBy = ''
  ) => {
    //  /marketplace/companies?page=1&perPage=10&sortBy=createdAt&orderBy=desc
    let url = `/marketplace/offers?page=${pageNumber}&perPage=${pageSize}&offerType=${listType}&search=${searchKey}&createdAt=${createdAt}&createdBy=${createdBy}`;

    // Add optional parameters if they have values
    //if (searchKey) url += `&searchKey=${encodeURIComponent(searchKey)}`;
    if (sortByKey) url += `&sortBy=${sortByKey}`;
    url += `&orderBy=${orderByKey}`;

    return GetApi(url, true);
  },

  getCreatorsList: () => GetApi(`/marketplace/offers/creators`, true),

  getMarketplaceOfferInsightsALL: () => GetApi(`/marketplace/offer/analytics`, true),

  getMarketplaceOfferInsights: (id) => GetApi(`/marketplace/offer/${id}/analytics`, true),

  // VIP Offers dashboard. `params`: from, to (YYYY-MM-DD), granularity,
  // audience, ageBand, ethnicity, brandId, offerId — empty values are dropped.
  getVipOfferAnalytics: (params = {}) => {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, value]) => value !== '' && value != null)
    ).toString();
    return GetApi(`/marketplace/vip-analytics${query ? `?${query}` : ''}`, true);
  },

  getVipOfferAnalyticsOptions: () => GetApi(`/marketplace/vip-analytics/options`, true),

  // E-Gifts dashboard, one vendor (voucherLine | BHN) and app tab
  // (e_gifts | my_tools | craft_drinks) at a time. Empty values are dropped.
  getEGiftAnalytics: (params = {}) => {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, value]) => value !== '' && value != null)
    ).toString();
    return GetApi(`/marketplace/egift-analytics?${query}`, true);
  },

  // Ello (Gourmet Society) tracking and management. Empty params are dropped.
  getElloOverview: (params = {}) => GetApi(`/marketplace/ello/overview?${toQuery(params)}`, true),
  getElloOptions: () => GetApi(`/marketplace/ello/options`, true),
  getElloCodes: (params = {}) => GetApi(`/marketplace/ello/codes?${toQuery(params)}`, true),
  getElloCompanies: (params = {}) => GetApi(`/marketplace/ello/companies?${toQuery(params)}`, true),
  uploadElloCodes: (codes) => PostApi('/marketplace/ello/codes/upload', { codes }, true),
  resendElloEmails: () => PostApi('/marketplace/ello/resend-unsent-emails', {}, true),
  assignMissingElloCodes: () => PostApi('/marketplace/ello/assign-missing-subscribers', {}, true),

  getEGiftAnalyticsOptions: (vendor, category) =>
    GetApi(`/marketplace/egift-analytics/options?vendor=${vendor}&category=${category}`, true),

  getVoucherOrders: (role = 'user', page = 1, limit = 10, searchKey = '', filters = {}) => {
    let url = `/voucher-orders?role=${role}&page=${page}&limit=${limit}`;
    if (searchKey) url += `&search=${searchKey}`;
    if (filters.paymentStatus && filters.paymentStatus !== '')
      url += `&paymentStatus=${filters.paymentStatus}`;
    if (filters.status && filters.status !== '') url += `&status=${filters.status}`;
    if (filters.companyId && filters.companyId !== '') url += `&company_id=${filters.companyId}`;
    return GetApi(url, true);
  },
  getVoucherOrderById: (orderId) => GetApi(`/voucher-orders/${orderId}`, true),
  getVoucherOrderCompanies: () => GetApi(`/voucher-orders/companies`, true),
  getB2BVoucherProductsByCompany: (page = 1, limit = 10) =>
    GetApi(`/company/v1/voucherline/products-by-company?page=${page}&limit=${limit}`, true),
  processVoucherOrder: (orderId, reqBody) =>
    PostApi(`/voucher-orders/${orderId}/process`, reqBody, true),
  updateVoucherOrderStatus: (orderId, reqBody) =>
    PutApi(`/voucher-orders/${orderId}/status`, reqBody, true),
  sendEgift: (orderId) => PostApi(`/voucher-orders/${orderId}/send-egift`, {}, true),

  delMarketplaceCompany: (id) => DeleteApi(`/marketplace/company/${id}`, true),

  postMarketplaceAddCompany: (reqBody) => PostApi('/marketplace/company', reqBody, true),

  postMarketplaceAddOffer: (reqBody) => PostApi('/marketplace/offer', reqBody, true),

  getMarketplaceOfferInfo: (id) => GetApi(`/marketplace/offer/${id}`, true),

  delMarketplaceOffer: (id) => DeleteApi(`/marketplace/offer/${id}`, true),

  // option api
  getCategoriesById: (id) => GetApi(`/getCategoriesByContentId/${id}`, true),

  // test feature APIs start
  postAddTest: (reqBody) => PostApi('/shoorah-test', reqBody, true),

  putUpdateTest: (id, reqBody) => PutApi(`/shoorah-test/${id}`, reqBody, true),

  getTestCatagory: () => GetApi('/getCategoriesByContentIdPopulate/21', true),

  getAllTests: (
    pageNumber,
    pageSize,
    sortByKey,
    orderByKey,
    statusCode,
    searchTerm,
    createdAtDate = '',
    categoriesList
  ) => {
    let url = `/shoorah-test?page=${pageNumber}&limit=${pageSize}&sortByKey=${sortByKey}&orderBy=${orderByKey}&status=${statusCode}`;

    // status, categories, search, createdAt
    if (searchTerm) url += `&search=${searchTerm}`;
    if (categoriesList) url += `&categories=${categoriesList}`;
    if (createdAtDate) url += `&createdAt=${createdAtDate}`;
    return GetApi(url, true);
  },

  getTestInfo: (id) => GetApi(`/shoorah-test/${id}`, true),

  postTestApprove: (contentid, reqBody) =>
    PostApi(`/shoorah-test/approval/${contentid}`, reqBody, true),

  getTestB2BCompaniesList: (pageNumber, pageSize, sortByKey, orderByKey, searchKey, createdAt) => {
    let url = `/shoorah-test/analytics/companies?page=${pageNumber}&limit=${pageSize}&sortBy=${sortByKey}&orderBy=${orderByKey}&search=${searchKey}`;

    return GetApi(url, true);
  },

  getAllUsersShoorahTestResults: (
    pageNumber,
    pageSize,
    sortByKey,
    orderByKey,
    searchTerm,
    companyId,
    createdAtDate = ''
  ) => {
    let url = `/shoorah-test/analytics/users?page=${pageNumber}&limit=${pageSize}&sortBy=${sortByKey}&orderBy=${orderByKey}`;
    // status, categories, search, createdAt
    if (companyId) url += `&companyId=${companyId}`;
    if (searchTerm) url += `&search=${searchTerm}`;
    if (createdAtDate) url += `&createdAt=${createdAtDate}`;
    return GetApi(url, true);
  },

  getTestResultsOverviews: (type, companyID) => {
    let url = `/shoorah-test/analytics/overview?type=${type}`;
    if (companyID) url += `&companyId=${companyID}`;
    return GetApi(url, true);
  },

  getUserTestReportBlob: async (testID) => {
    try {
      const res = await axios.get(
        BASE_URL + `admin/v1/shoorah-test/test/report/${testID}?type=pdf`,
        {
          headers: {
            deviceType: 3,
            Authorization: getJWTToken(),
            Accept: 'application/pdf'
          },
          responseType: 'arraybuffer' // This is crucial for PDF data
        }
      );
      return res;
    } catch (err) {
      ErrorHandler(err);
      throw err;
    }
  },

  delTest: (id) => DeleteApi(`/shoorah-test/${id}`, true),

  // add on api
  AddUser: (reqBody) => PostApi('/add-user', reqBody, true),
  resendWelcomeEmail: (reqBody) => PostApi('/resend-welcome-email', reqBody, true),

  getPodExperts: (reqBody) => {
    // Built from the body rather than hardcoded: this used to forward only
    // page/limit/search, so the status tabs and the expert-type filter sent
    // their values nowhere and the list never changed.
    const params = new URLSearchParams({
      page: reqBody?.page ?? 1,
      limit: reqBody?.limit ?? 10,
      search: reqBody?.search ?? ''
    });
    // `0` is a real value for both — a truthiness check would drop
    // "Disabled" and "Pod Expert".
    if (reqBody?.isActive !== undefined && reqBody?.isActive !== '')
      params.set('isActive', reqBody.isActive);
    if (reqBody?.type !== undefined && !Number.isNaN(reqBody.type))
      params.set('type', reqBody.type);
    return GetApi(`/pod-expert-profile?${params.toString()}`, true);
  },
  addPodExperts: (reqBody) => PostApi('/pod-expert-profile', reqBody, true, true),
  updatePodExperts: (reqBody) => PutApi('/pod-expert-profile', reqBody, true),
  getPodExpertById: (id) => GetApi(`/pod-expert-profile?id=${id}`, true),
  getPodExpertsName: (id) => GetApi(`/pod-expert-name-list`, true),
  getPodExpertStats: () => GetApi(`/pod-expert-stats`, true),

  downloadSosGraphPdf: (startDate, endDate, reportType) =>
    DownloadApi(
      `/downloadSosClickReport?${
        reportType === 3
          ? `reportType=${reportType}&startDate=${startDate}&endDate=${endDate}`
          : `reportType=${reportType}`
      }`
    ),

  getB2BviaGraphData: () => GetApi(`/getB2BviaGraph`, true),
  getB2bMoodData: () => GetApi(`/getB2BAdminMoodCounts`, true),

  getB2BEarningsGraphData: (id) => GetApi(`/getB2BEarningsGraph?companyId=${id}`, true),

  getUserPlansData: (type) => GetApi(`/getUserPlansData?type=${type}`, true),
  getGoogleAnalyticsData: (startDate, endDate, reportType) =>
    GetApi(
      `/googleAnalyticsData?reportType=${reportType}&startDate=${startDate}&endDate=${endDate}`,
      true
    ),

  getShuruUsageData: (startDate, endDate) =>
    GetApi(`/getShuruUsageTime?${`&startDate=${startDate}&endDate=${endDate}`}`, true),
  getAppIssues: (page, perPage) => GetApi(`/getAppIssues?page=${page}&perPage=${perPage}`, true),
  updateAppIssues: (reqBody) => PostApi(`/updateAppIssue`, reqBody, true),
  downloadAppIssue: (id) => GetApi(`/app-issue/${id}`, true),

  addEditPartner: (reqBody) => PostApi(`/add-partner`, reqBody, true),
  deletePartner: (userId) => DeleteApi(`/partners?userId=${userId}`, true),
  getPartners: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/partners?id=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}${filterQuery}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  getIntroduceCompanies: (page, perPage, searchKey, filterQuery, sortBy) =>
    GetApi(
      `/introduce-companies?page=${page}&perPage=${perPage}&searchKey=${searchKey}${filterQuery}&sortBy=${sortBy}`,
      true
    ),
  // Surveys and ideas api starts from here
  getAllSurvey: (page, perPage, surveyName, draft, createdBy, createdOn) =>
    GetApi(
      `/survey?page=${page}&perPage=${perPage}&surveyName=${surveyName}&draft=${draft}&createdBy=${createdBy}&createdOn=${createdOn}`,
      true
    ),
  getAllCategory: () => GetApi('/category', true),
  addCategory: (reqBody) => PostApi('/category', reqBody, true),
  deleteSurvey: (surveyId) => DeleteApi(`/survey-delete?id=${surveyId}`, true),
  getSurveySummary: (surveyId) => GetApi(`/summary/${surveyId}`),
  getSurveyInsight: (surveyId) => GetApi(`/insights/${surveyId}`),
  uploadImage: (reqBody) => PostApi('/survey/upload', reqBody, true, true),
  getSurveyDashboardData: (type) => GetApi(`/company-dashboard?survey_count_type=${type}`, true),
  getSurveyTemplateList: (type) =>
    GetApi(`/survey-template${type ? '?template_type=' + type : ''}`, true),
  getSurveyInsights: (type) =>
    GetApi('/survey-template?result_type=insight' + (type ? `&template_type=${type}` : ''), true),
  getReport: (fileName = 'Question Summary') =>
    DownloadApi(`/survey/report?fromDate=2024-01-02&toDate=2024-02-04`, fileName),
  addSurvey: (reqBody) => PostApi('/survey', reqBody, true),
  updateSurvey: (surveyId, reqBody) => PutApi(`/survey/${surveyId}`, reqBody, true, true),
  getSurvey: (id) => GetApi(`/survey/${id}`, true),
  getCompanySurveyDashboardData: (companyId) =>
    GetApi('/company-dashboard?companyId=' + companyId, true),

  editIntroCompany: (reqBody) => PostApi(`/edit-introduce`, reqBody, true),
  getJobsPercent: (reqBody) => PostApi(`/get-jobs-percent`, reqBody, true),
  importUsers: (file, onUploadProgress) =>
    PostApi(`/import-users`, file, true, true, onUploadProgress),
  b2bAdminList: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id, companyId) =>
    GetApi(
      `/b2b-admin-list?id=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}${filterQuery}&sortBy=${sortBy}&sortOrder=${sortOrder}&companyId=${companyId}`,
      true
    ),

  deleteB2BAdmin: (id, company) => DeleteApi(`/delete-admin?id=${id}&company=${company}`, true),

  downloadB2BReport: (reqBody) => PostApi(`/b2b-overall-report`, reqBody, true),
  cancelSubscriptionUser: (reqBody) => PostApi(`/cancel-subscription`, reqBody, true),
  resentCredUsers: (reqBody) => PostApi(`/resend-creds`, reqBody, true),
  addTrialDays: (reqBody) => PostApi(`/add-user-trial`, reqBody, true),

  // vision ideas
  getDraftVisionIdeasList: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/draft-idea?id=${id ? id : ''}&page=${page}&perPage=${perPage}&searchKey=${searchKey}${
        filterQuery || ''
      }&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),

  getVisionIdeasList: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/idea?id=${id ? id : ''}&page=${page}&perPage=${perPage}&searchKey=${searchKey}${
        filterQuery || ''
      }&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  deleteVisionIdea: (visionId) => DeleteApi(`/idea-delete?ideaId=${visionId}`, true),
  addDraftVisionIdeas: (reqBody) => PostApi('/draft-idea', reqBody, true),
  addVisionIdeas: (reqBody) => PostApi('/idea', reqBody, true),
  getVisionIdeasById: (id) => GetApi(`/idea/${id}`, true),
  // Surveys and ideas api ends from here

  rippleUsage: (startDate, endDate, timeConstant) =>
    GetApi(
      `/ripple-usage?startDate=${startDate}&endDate=${endDate}&timeConstant=${timeConstant}`,
      true
    ),
  rippleReport: (startDate, endDate, timeConstant) =>
    DownloadApi(
      `/ripple-report?startDate=${startDate}&endDate=${endDate}&timeConstant=${timeConstant}`,
      `Ripple-report`
    ),

  getSleepLogPercent: () => GetApi(`/get-before-sleep`, true),
  getAfterSleepLogPercent: () => GetApi(`/get-after-sleep`, true),
  getSleepLogs: (userId, reportType) =>
    GetApi(`/get-sleep-logs?userId=${userId}&reportType=${reportType}`, true),
  //Breathwork
  getBreathworkList: (page, perPage, searchKey, sortBy, sortOrder, id) =>
    GetApi(
      `/breathwork?id=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  getExpertBreathworkList: (page, perPage, searchKey, sortBy, sortOrder, id) =>
    GetApi(
      `/breathwork?expertId=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  getDraftBreathworksList: (page, perPage, searchKey, sortBy, sortOrder, id) =>
    GetApi(
      `/draft-breathwork?id=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  getBreathworkById: (id) => GetApi(`/breathwork/${id}`, true),
  addBreathwork: (reqBody) => PostApi('/breathwork', reqBody, true),
  addDraftbreathwork: (reqBody) => PostApi('/draft-breathwork', reqBody, true),
  deleteBreathwork: (breathworkId) => DeleteApi(`/breathwork?breathworkId=${breathworkId}`, true),

  getBreathworkInsights: () => GetApi(`/breathwork-insights`, true),
  addSolutionData: (body) => PostApiBlob('/breathwork-solution', body, true),
  addBreathworkReportData: (body) => PostApiBlob('/add-breathwork-report', body, true),

  getSolutionTextFromOpenAi: (body) =>
    axios
      .post(BASE_URL + 'api/v1/openai', body, {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
          deviceToken: getLocalStorageItem('deviceToken'),
          deviceType: 3,
          Authorization: getJWTToken()
        }
      })
      .then((data) => {
        return data;
      })
      .catch(async (e) => {
        ErrorHandler(e);
      }),
  getSrtDatawithUrl: (url) => GetApi(`/srt-convert-text?url=${url}`, true),
  getUserActivityStats: (startDate, endDate) =>
    GetApi(`/count-users-and-usage?startDate=${startDate}&endDate=${endDate}`, true),
  updateSrtData: (reqBody) => PostApi(`/update-srt`, reqBody, true),

  getUserWellJournalData: (reportType, userId) =>
    GetApi(`/user-wellbeing-journal-data?reportType=${reportType}&userId=${userId}`, true),
  getUserWellShuruData: (reportType, userId) =>
    GetApi(`/user-wellbeing-shuru-data?reportType=${reportType}&userId=${userId}`, true),
  getUserWellPersonalData: (reportType, userId) =>
    GetApi(`/user-wellbeing-personal-data?reportType=${reportType}&userId=${userId}`, true),
  getUserWellProfessionalData: (reportType, userId) =>
    GetApi(`/user-wellbeing-professional-data?reportType=${reportType}&userId=${userId}`, true),

  getOverallWellJournalData: (reportType) =>
    GetApi(`/overall-wellbeing-journal-data?reportType=${reportType}`, true),
  getOverallWellShuruData: (reportType) =>
    GetApi(`/overall-wellbeing-shuru-data?reportType=${reportType}`, true),
  getOverallWellPersonalData: (reportType) =>
    GetApi(`/overall-wellbeing-personal-data?reportType=${reportType}`, true),
  getOverallWellProfessionalData: (reportType) =>
    GetApi(`/overall-wellbeing-professional-data?reportType=${reportType}`, true),
  getOverallWellReport: (reqBody) => PostApiBlob(`/overall-wellbeing-report`, reqBody, true),
  getSpecialistData: (page, perPage, userId, searchKey, status) =>
    GetApi(
      `/peap-expert-profile-get?approve_status=${status}&page=${page}&perPage=${perPage}&id=${userId}&searchKey=${encodeURIComponent(
        searchKey
      )}`,
      true
    ),
  postSpecialistData: (reqBody) => PostApi('/add-expert', reqBody, true),
  getApprovalsList: () => GetApi('/get-all-admin-request', true),
  updateApprovalsStatus: (reqBody) => PutApi('/update-request-to-admin', reqBody, true),

  // addEditPulseSurvey: (reqBody) => PostApi('/add-edit-survey', reqBody, true),
  // addEditPulseSurveyCategory: (reqBody) => PostApi('/add-edit-categories', reqBody, true),
  // getPulseSurveyCategories: () => GetApi(`/get-categories`, true),
  // getPulseSurveys: (page, perPage, isDraft, isTemplate, surveyStatus, searchKey) =>
  //   GetApi(
  //     `/get-surveys?page=${page}&perPage=${perPage}&isDraft=${isDraft}&isTemplate=${isTemplate}&surveyStatus=${surveyStatus}&searchKey=${searchKey}`,
  //     true
  //   ),
  // getPulseSurveyById: (surveyId) => GetApi(`/get-survey-by-id?surveyId=${surveyId} `, true),
  // deletePulseSurvey: (id) => DeleteApi(`/delete-survey?surveyId=${id}`, true),
  // subAdminIsDraft: (page, perPage, isDraft, isTemplate, surveyStatus, searchKey) =>
  //   GetApi(
  //     `/get-surveys?page=${page}&perPage=${perPage}&isDraft=${true}&isTemplate=${isTemplate}&surveyStatus=${surveyStatus}&searchKey=${searchKey}`,
  //     true
  //   ),
  getTemplates: () => GetApi('/get-templates', true),

  getAllUsersEmotions: (queryString) => GetApi(`/get-user-emotions${queryString}`, true),
  getUserEmotion: (queryString) => GetApi(`/get-emotions${queryString}`, true),

  getFeedbacksList: (page, perPage, searchKey, filters, sortBy, sortOrder) => {
    const isSortingByContentName = sortBy === 'display_name';
    return GetApi(
      `/get-user-feeds?page=${page}&perPage=${perPage}&searchKey=${searchKey}${filters}${
        isSortingByContentName
          ? `&sortBy=${sortBy}&sortOrder=${sortOrder}`
          : `&sortByFeedbackType=${sortBy}&sortOrderFeedback=${sortOrder}`
      }`,
      true
    );
  },
  // Pulse Survey
  // createPulseSurvey: (reqBody) => PostApi('/survey', reqBody, true, false),
  // deletePulseSurvey: (surveyId) => DeleteApi(`/survey?id=${surveyId}`, true),
  // getByIdPulseSurvey: (surveyId) => GetApi(`/survey?id=${surveyId}`, true),

  // Self assessment
  createAssessment: (reqBody) => PostApi('/self-assessment', reqBody, true, false),
  editAssessment: (reqBody) => PutApi('/self-assessment', reqBody, true, false),
  getAssessment: (currentPage, searchTerm, assessmentStatus, limit, id) =>
    GetApi(
      `/self-assessment?page=${
        currentPage || 1
      }&search=${searchTerm}&status=${assessmentStatus}&limit=${limit}&id=${id}`,
      true
    ),
  getAssessmentMatrics: (company_id, query) =>
    GetApi(
      '/self-assessment/metrics?company_id=' +
        (company_id ? company_id : '') +
        (query ? query : ''),
      true
    ),
  getAssessmentResult: (assessmentId) =>
    GetApi(`/self-assessment/results?SelfAssessmentId=${assessmentId}`, true),
  getAdminList: () => GetApi('/admins?userType=0&accountStatus=1', true),
  deleteAssessment: (assessmentId) => DeleteApi(`/self-assessment?id=${assessmentId}`, true),
  getAllProfessionals: (page = 1, limit = 50) =>
    GetApi(`/expert?type=1&page=${page}&limit=${limit}`, true),
  approveAssessment: (reqBody) => PostApi('/self-assessment/approval', reqBody, true, false),

  // Survey
  submitApproval: (reqBody) => {
    return PostApi('/survey-approval', reqBody, true);
  },

  //Peap API's

  inviteToInterview: (reqBody) => PostApi('/expert-profile-action', reqBody, true),
  approvePeap: (reqBody) => PostApi('/inviteToInterview', reqBody, true),
  declinePeap: (reqBody) => PostApi('/inviteToInterview', reqBody, true),
  getPeapExpertList: (page, perPage) => {
    return GetApi(`/get-expert-status-list?page=${page}&perPage=${perPage}`, true);
  },

  // getAccountInfo: (expertId) => GetApi(`/get-expert-account-info?expertId=${expertId}`, true),

  getPeapAccountInfo: (expertId) => GetApi(`/get-expert-profile?id=${expertId}`, true),
  updatePeapExpertProfileDocStaus: (reqBody, expertId) =>
    PutApi(`/update-expert-doc-verification-status/${expertId}`, reqBody, true),
  updatePeapExpertProfileStatus: (reqBody) =>
    PatchApi('/peap-expert-profile-update', reqBody, true),
  updatePeapExpertaccountStatus: (reqBody) =>
    PutApi('/update-expert-account-status', reqBody, true),
  updateComplaintStatus: (reqBody) => PutApi('/update-complaint-status', reqBody, true),
  updatePeapExpertProfilePrize: (id, reqBody) =>
    PatchApi(`/peap-expert-profile-update-price/${id}`, reqBody, true),
  getAdminTutorialsList: (params) => GetApi(`/tutorial?${encodeQueryData(params)}`, true),
  getAdminSingleTutorial: (id) => GetApi(`/tutorial/${id}`, true),
  createAdminTutorial: (reqBody) => PostApi(`/tutorial`, reqBody, true),
  updateAdminTutorial: (id, reqBody) => PutApi(`/tutorial/${id}`, reqBody, true),
  dashAdminTutorial: (reqBody) => GetApi(`/tutorial/count`, true),
  updateAdminTutorialStatus: (reqBody) => PutApi(`/tutorial/update-status`, reqBody, true),
  uploadVideo: (reqBody) => PostApi(`/tutorial/upload-video`, reqBody, true, true),

  addChallange: (reqBody) => PostApi('/badges/challenge', reqBody, true),
  getChallanges: (query) => GetApi(`/badges/challenge?${query}`, true),
  editChallange: (reqBody) => PutApi('/badges/challenge', reqBody, true),
  deleteChallange: (id) => DeleteApi(`/badges/challenge?id=${id}`, true),

  addReward: (reqBody) => PostApi('/badges/reward', reqBody, true),
  getRewards: (query) => GetApi(`/badges/reward?${query}`, true),
  editReward: (reqBody) => PutApi('/badges/reward', reqBody, true),
  deleteReward: (id) => DeleteApi(`/badges/reward?id=${id}`, true),

  // Super Admin: Peap
  // Specialist Manager: payment tab
  getTransactionData: (page, perPage, filterQuery) =>
    GetApi(`/get-transaction-list?page=${page}&limit=${perPage}${filterQuery}`, true),
  getTransactionDetails: (id) => GetApi(`/get-transaction-details/${id}`, true),
  getPayoutExpertList: (companyId) => GetApi(`/get-payout-expert-list?search=${companyId}`, true),
  updatePayoutStatus: (reqBody) => PutApi('/update-payout-status', reqBody, true, true),

  // Sleep Hub (Admin "Sleep" section: dashboards + logs) — super/sub admin only
  getSleepSoundsDashboard: () => GetApi('/sleep-hub/sounds-dashboard', true),
  getSleepTrackerDashboard: () => GetApi('/sleep-hub/tracker-dashboard', true),
  getSleepHubCompanies: (page = 1, perPage = 10, search = '') =>
    GetApi(
      `/sleep-hub/companies?page=${page}&perPage=${perPage}&search=${encodeURIComponent(search)}`,
      true
    ),
  getSleepHubCompanyDetail: (companyId) => GetApi(`/sleep-hub/companies/${companyId}`, true),
  getSleepHubUsers: (page = 1, perPage = 10, search = '', accountType = '', companyId = '') =>
    GetApi(
      `/sleep-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
        search
      )}&accountType=${accountType}&companyId=${companyId}`,
      true
    ),
  getSleepHubUserDetail: (userId) => GetApi(`/sleep-hub/users/${userId}`, true),

  // Breathwork Hub (Admin "Breathwork" section: dashboards + logs) — super/sub admin only
  getBreathworkAudioDashboard: () => GetApi('/breathwork-hub/sounds-dashboard', true),
  getBreathworkSessionsDashboard: () => GetApi('/breathwork-hub/sessions-dashboard', true),
  getBreathworkHubCompanies: (page = 1, perPage = 10, search = '') =>
    GetApi(
      `/breathwork-hub/companies?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
        search
      )}`,
      true
    ),
  getBreathworkHubCompanyDetail: (companyId) =>
    GetApi(`/breathwork-hub/companies/${companyId}`, true),
  getBreathworkHubUsers: (page = 1, perPage = 10, search = '', accountType = '', companyId = '') =>
    GetApi(
      `/breathwork-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
        search
      )}&accountType=${accountType}&companyId=${companyId}`,
      true
    ),
  getBreathworkHubUserDetail: (userId) => GetApi(`/breathwork-hub/users/${userId}`, true),

  // Habits Hub (Admin "Habit Tracker" section: dashboards + logs) — super/sub admin only
  getHabitsHubDashboard: (scope = '') => GetApi(`/habits-hub/dashboard?scope=${scope}`, true),
  getHabitsHubCompanies: (page = 1, perPage = 10, search = '') =>
    GetApi(
      `/habits-hub/companies?page=${page}&perPage=${perPage}&search=${encodeURIComponent(search)}`,
      true
    ),
  getHabitsHubCompanyDetail: (companyId) => GetApi(`/habits-hub/companies/${companyId}`, true),
  getHabitsHubUsers: (page = 1, perPage = 10, search = '', accountType = '', companyId = '') =>
    GetApi(
      `/habits-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
        search
      )}&accountType=${accountType}&companyId=${companyId}`,
      true
    ),
  getHabitsHubUserDetail: (userId) => GetApi(`/habits-hub/users/${userId}`, true),

  //badges
  getBadges: (status = 'published') => GetApi(`/badgesV2/badge?status=${status}`, true),
  getBadgeImageLibrary: () => GetApi('/badgesV2/badge-image-library', true),
  addBadge: (reqBody) => PostApi('/badgesV2/badges', reqBody, true, true),
  deleteBadge: (id) => DeleteApi(`/badgesV2/badge/${id}`, true),
  updateBadgeTasks: (body) =>
    PutApiWithFormData('/badgesV2/badge-with-tasks-create-update', body, true, false),

  // Badge Dashboard & Stats
  getBadgeDashboardState: () => GetApi('/badgesV2/badge-dashboard-stats', true),
  getAdminBadgeDashboardState: () => GetApi('/badgesV2/badge-dashboard-stats', true),

  // Badge Winners
  getBadgeWinner: (page, badge_id) =>
    GetApi(`/badgesV2/badge/winners?badge_id=${badge_id}&page=${page}`, true),

  // B2C Users
  getB2CUsers: (
    page,
    searchTerm = '',
    startDate = '',
    recordsPerPage = 10,
    gender = '',
    ethnicity = ''
  ) =>
    GetApi(
      `/badgesV2/badges-users?page=${page}&keyword=${searchTerm}&startDate=${startDate}&perPage=${recordsPerPage}&gender=${gender}&ethnicity=${encodeURIComponent(
        ethnicity
      )}`,
      true
    ),
  getUserBadgeProgress: (userId, badgeId) =>
    GetApi(`/badgesV2/user-badge-progress?userId=${userId}&badgeId=${badgeId}`, true),
  getBadgeWinnersAll: (badgeId, page, keyword = '', perPage = 10) =>
    GetApi(
      `/badgesV2/badge-winners-all?badge_id=${badgeId}&page=${page}&keyword=${keyword}&perPage=${perPage}`,
      true
    ),

  // B2B Operations
  getB2BDashboardState: () => GetApi('/badgesV2/b2b-stats', true),
  getB2BCompanies: (page, searchTerm = '') =>
    GetApi(`/badgesV2/b2b-stats-companies?page=${page}&keyword=${searchTerm}`, true),
  getB2BCompanyById: (id, page, searchTerm = '', department = '', gender = '', ethnicity = '') =>
    GetApi(
      `/badgesV2/company-users?companyId=${id}&page=${page}&keyword=${searchTerm}&department=${encodeURIComponent(
        department
      )}&gender=${gender}&ethnicity=${encodeURIComponent(ethnicity)}`,
      true
    ),

  addManualSelectWinners: (reqBody, id) =>
    PostApi(`/challenge/${id}/manual-select-winners`, reqBody, true, false),
  sendEmailWinners: (reqBody, id) =>
    PostApi(`/challenge/${id}/send-winner-email`, reqBody, true, false),

  //task api
  getTaskListing: (startDate = '', searchTerm = '') =>
    GetApi(`/challenge/taskssummary?search=${searchTerm}&date=${startDate}`, true),
  getTaskWithStatus: (currentPage, startDate = '', searchTerm = '', status) =>
    GetApi(
      `/challenge/paginated-tasks?page=${currentPage}&search=${searchTerm}&date=${startDate}&status=${status}`,
      true
    ),
  deleteIndTask: (id) => DeleteApi(`/challenge/independent-tasks?taskId=${id}`, true),
  addUpdateTask: (reqBody) =>
    PostApi('/challenge/createOrUpdateIndependentTask', reqBody, true, false),
  getTaskById: (id) => GetApi(`/challenge/independent-tasks?taskId=${id}`, true),

  // B2B WellPoints
  getWellpointTransactionData: (page, perPage, filterQuery) =>
    GetApi(`/get-wellpoints-transaction-list?page=${page}&limit=${perPage}${filterQuery}`, true),
  getWellpointsCount: () => GetApi('/get-wellpoints-count', true),
  getWellPointTransactionDataById: (id) => GetApi(`/get-wellpoints-transaction-list/${id}`, true),
  updateWellpointsHistory: (reqBody) => PutApi('/update-wellpoints-history', reqBody, true, true),
  updateWellpointsCustomHistory: (reqBody) =>
    PutApiWithFormData('/update-wellpoints-history-custom', reqBody, true, true),
  updateWellpointsHistoryStatus: (reqBody) =>
    PutApi('/update-wellpoints-history-status', reqBody, true, true),
  updateWellpointsHistoryEmailStatus: (reqBody) =>
    PutApi('/update-wellpoints-history-email-status', reqBody, true, true),
  getComplaintList: (page, perPage, status, search = '') =>
    GetApi(
      `/get-complaints?page=${page}&perPage=${perPage}&status=${status}&search=${encodeURIComponent(
        search
      )}`,
      true
    ),
  getPeapDashboard: (page, perPage, status) => GetApi(`/peep-dashboard`, true),

  // Challenges API
  getChallenges: (startDate, search) => {
    const url = `/challenge/stats?startDate=${startDate ? startDate : ''}&search=${
      search ? search : ''
    }`;
    return GetApi(url, true);
  },
  getListChallenges: (status, page, perPage, search, startDate, isExpire) =>
    GetApi(
      `/challenge/challenges?status=${status}&page=${page ? page : ''}&limit=${
        perPage ? perPage : ''
      }&search=${search ? search : ''}&startDate=${startDate ? startDate : ''}&isExpire=${
        isExpire ? isExpire : false
      }`,
      true
    ),
  getSpecificChallenges: (id) => GetApi(`/challenge/${id}`, true),
  addChallengesDeyails: (reqBody) =>
    PostApi('/challenge/createOrUpdateChallenge', reqBody, true, true),
  addChallengesTask: (reqBody) => PostApi('/challenge/createOrUpdateTasks', reqBody, true, false),
  addChallengesReward: (reqBody) => PostApi('/challenge/createOrUpdateReward', reqBody, true, true),
  getChallengesReward: (id) => GetApi(`/challenge/${id}/rewards`, true),
  updateChallengesStatus: (reqBody, id) => PatchApi(`/challenge/${id}/status`, reqBody, true),
  getWinnersList: (id, page, limit) =>
    GetApi(`/challenge/${id}/winners?limit=${limit ? limit : ''}&page=${page ? page : ''}`, true),
  addRandomWinner: (reqBody, id) =>
    PostApi(`/challenge/${id}/select-winners`, reqBody, true, false),
  getDepartmentList: (id) => GetApi(`/get-departments/${id}`, true),
  convertChallengesFromTemplate: (reqBody) =>
    PostApi(`/challenge/createChallenges`, reqBody, true, false),

  //------shoorah benefits
  getbenefitsList: (page, perPage, searchKey, planType, benefitStatus, createdAt, id) =>
    GetApi(
      `/benefits?page=${page}&perPage=${perPage}&searchKey=${searchKey ? searchKey : ''}&planType=${
        planType ? planType : ''
      }&benefitStatus=${benefitStatus ? benefitStatus : ''}&createdAt=${
        createdAt ? createdAt : ''
      }&id=${id ? id : ''}`,
      true
    ),
  getBenefitStatus: () => GetApi('/benefit/stats', true),
  deleteBenefit: (reqBody) => PutApi('/benefit/delete', reqBody, true, true),
  updateBenefitStatus: (reqBody) => PutApi('/benefit/update-status', reqBody, true, true),
  addCustomPlansBenefits: (reqBody) => PostApi(`/benefit`, reqBody, true, false),
  setupPassword: (reqBody) => PostApi('/reset-password', reqBody, false),
  ModifyPassword: (reqBody) => PostApi('/modify-password', reqBody, false),

  // Third-Party API Partners Management (for Shoorah Test APIs)
  getAPIPartnersList: (page, perPage, search, isActive, sortBy, sortOrder) => {
    let url = `/api-partners?page=${page}&perPage=${perPage}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (isActive !== undefined && isActive !== '') url += `&isActive=${isActive}`;
    if (sortBy) url += `&sortBy=${sortBy}&sortOrder=${sortOrder}`;
    return GetApi(url, true);
  },
  createAPIPartner: (reqBody) => PostApi(`/api-partners`, reqBody, true),
  getAPIPartnerDetails: (partnerId) => GetApi(`/api-partners/${partnerId}`, true),
  updateAPIPartnerLimit: (reqBody) => PutApi(`/api-partners/update-limit`, reqBody, true),
  resetAPIPartnerUsage: (reqBody) => PostApi(`/api-partners/reset-usage`, reqBody, true),
  toggleAPIPartnerStatus: (partnerId) =>
    PutApi(`/api-partners/${partnerId}/toggle-status`, {}, true),
  deleteAPIPartner: (partnerId) => DeleteApi(`/api-partners/${partnerId}`, true),
  updateWearableAccess: (reqBody) => PostApi(`/wearable-subscription/grant`, reqBody, true),
  getWearableAccessOfUser: (userId) => GetApi(`/wearable-subscription?userId=${userId}`, true),

  // ===================================== Health Scheme =====================================

  // Get all health schemes (admin)
  getHealthSchemesList: (page, perPage, searchKey) =>
    GetApi(
      `/health-scheme/schemes?page=${page}&perPage=${perPage}&searchKey=${searchKey || ''}`,
      true
    ),

  // Create or update health scheme (admin)
  addEditHealthScheme: (reqBody) => PostApi('/health-scheme/scheme', reqBody, true, false),

  // Update health scheme status (admin)
  updateHealthSchemeStatus: (reqBody) =>
    PutApi('/health-scheme/scheme/status', reqBody, true, false),

  // Toggle health scheme visibility (admin)
  toggleHealthSchemeVisibility: (reqBody) =>
    PutApi('/health-scheme/scheme/visibility', reqBody, true, false),

  // Get health schemes statistics (admin)
  getHealthSchemesStats: () => GetApi('/health-scheme/schemes/stats', true),

  // Delete health scheme (admin)
  deleteHealthScheme: (schemeId) =>
    DeleteApi(`/health-scheme/scheme/delete?schemeId=${schemeId}`, true),

  // Get companies with health schemes
  getCompaniesWithHealthScheme: (page, perPage, searchKey, isActive) => {
    let url = `/health-scheme/companies-with-schemes?page=${page}&limit=${perPage}`;
    if (searchKey) url += `&searchKey=${encodeURIComponent(searchKey)}`;
    if (isActive !== undefined && isActive !== null) url += `&isActive=${isActive}`;
    return GetApi(url, true);
  },
  // Create Shoorah scheme for a company
  createShoorahHealthScheme: (reqBody) => PostApi('/health-scheme/scheme', reqBody, true, false),
  // Get unenrolled users of a company
  getHealthSchemeUnenrolledUsers: (companyId, searchKey) => {
    let url = `/health-scheme/company-users?companyId=${companyId}`;
    if (searchKey) url += `&searchKey=${encodeURIComponent(searchKey)}`;
    return GetApi(url, true);
  },
  // Enroll users in a health scheme
  enrollUsersInHealthScheme: (reqBody) =>
    PostApi('/health-scheme/scheme/enroll-users', reqBody, true, false),
  // ===================================== Salary Sacrifice (Shoorah Admin) =====================================

  // Get companies with salary sacrifice schemes
  getCompaniesWithSalarySacrifice: (page, perPage, searchKey, isActive) => {
    let url = `/salary-sacrifice/companies-with-schemes?page=${page}&limit=${perPage}`;
    if (searchKey) url += `&searchKey=${encodeURIComponent(searchKey)}`;
    if (isActive !== undefined && isActive !== null) url += `&isActive=${isActive}`;
    return GetApi(url, true);
  },

  // Get companies list for dropdown (only companies without active schemes)
  getSalarySacrificeCompaniesList: (page, perPage, searchKey) => {
    let url = `/salary-sacrifice/companies-list`;
    if (searchKey) url += `?searchKey=${encodeURIComponent(searchKey)}`;
    return GetApi(url, true);
  },

  // Get unenrolled users of a company
  getSalarySacrificeUnenrolledUsers: (companyId, searchKey) => {
    let url = `/salary-sacrifice/company-users?companyId=${companyId}`;
    if (searchKey) url += `&searchKey=${encodeURIComponent(searchKey)}`;
    return GetApi(url, true);
  },

  // Get enrolled users of a company
  getSalarySacrificeEnrolledUsers: (companyId, page, perPage, searchKey) => {
    let url = `/salary-sacrifice/enrollments?companyId=${companyId}&page=${page}&perPage=${perPage}`;
    if (searchKey) url += `&searchKey=${encodeURIComponent(searchKey)}`;
    return GetApi(url, true);
  },

  // Create Shoorah scheme for a company
  createShoorahSalarySacrificeScheme: (reqBody) =>
    PostApi('/salary-sacrifice/scheme', reqBody, true, false),

  // Enroll users in a salary sacrifice scheme
  enrollUsersInSalarySacrifice: (reqBody) =>
    PostApi('/salary-sacrifice/enroll-users', reqBody, true, false),

  // Toggle user enrollment status
  toggleSalarySacrificeEnrollment: (reqBody) =>
    PatchApi('/salary-sacrifice/toggle-enrollment', reqBody, true, false),

  // Delete salary sacrifice scheme
  deleteSalarySacrificeScheme: (schemeId) =>
    DeleteApi(`/salary-sacrifice/scheme/${schemeId}`, true),

  getActiveSalarySacrificeByCompId: (companyId) =>
    GetApi(`/salary-sacrifice/active-scheme?companyId=${companyId}`, true),
  getSalarySchemeById: (schemeId) =>
    GetApi(`/salary-sacrifice/scheme-by-id?schemeId=${schemeId}`, true),
  getSalarySacrificeIcons: () => GetApi(`/salary-sacrifice/fetch-icon-list`, true),

  createCustomSalaryScheme: (payload) => PostApi(`/salary-sacrifice/scheme`, payload, true, false),
  UpdateCustomSalaryScheme: (schemeId, payload) =>
    PutApi(`/salary-sacrifice/scheme/${schemeId}`, payload, true, false),

  // ===================================== Health Scheme (Shoorah Admin) =====================================
  getActiveHealthSchemeByCompId: (companyId) =>
    GetApi(`/health-scheme/active-scheme?companyId=${companyId}`, true),
  getHealthSchemeById: (schemeId) =>
    GetApi(`/health-scheme/scheme-by-id?schemeId=${schemeId}`, true),
  getHealthSchemeIcons: () => GetApi(`/health-scheme/fetch-icon-list`, true),

  createCustomHealthScheme: (payload) => PostApi(`/health-scheme/scheme`, payload, true, false),
  UpdateCustomHealthScheme: (schemeId, payload) =>
    PutApi(`/health-scheme/scheme/${schemeId}`, payload, true, false)
};
